import React from 'react';
import { PACKAGING } from '@monorepo/dictionary';
import { SelectField, TFormField } from '@monorepo/forms';
import { enumToSelectOptions } from '@monorepo/helpers';
import { prepareOptions } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';

const PackagingSelect = <
  TFormValues extends Record<string, any> = Record<string, any>
>(
  props: TFormField<TFormValues>
) => {
  const { t } = useI18n();

  // Choose correct constants based on flag
  const conditionEnum = PACKAGING;
  const translationPrefix = 'packaging.';

  return (
    <SelectField<TFormValues>
      options={prepareOptions(
        enumToSelectOptions(conditionEnum),
        t,
        translationPrefix
      )}
      {...props}
    />
  );
};

export default PackagingSelect;
